import React, { useState, useEffect } from "react";
import {
  Modal,
  Paper,
  Typography,
  IconButton,
  Button,
  Input,
  Grid,
  TextField,
  useTheme,
} from "@mui/material";
import {
  InputLabel,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import { toastAlert } from "../../../utils/AlertContext";
import { getAddPortadaURL, getUpdatePortadaURL } from "../../../utils/ConstantsURL";

const AddPortadas = ({
  token,
  open,
  close,
  initialPortadaData,
  idDocument,
  sections,
  portadas,
  refresh
}) => {
  const [portadaData, setPortadaData] = useState({
    title: "",
    imagen: "",
    image: null,
    seccion_id: "",
  });
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const isEdit = Boolean(initialPortadaData && initialPortadaData.id);

  const availableSections = sections.filter(
    (section) =>
      !portadas.some(
        (portada) => portada.seccion_id === section.ID_SECCION
      ) || (isEdit && portadaData.seccion_id === section.ID_SECCION)
  );

  useEffect(() => {
    if (initialPortadaData) {
      setPortadaData({
        title: initialPortadaData.titulo || "",
        imagen: initialPortadaData.imagen || "",
        image: initialPortadaData.url || null,
        seccion_id: initialPortadaData.seccion_id || "",
      });
    } else {
      setPortadaData({
        title: "",
        imagen: "",
        image: null,
        seccion_id: "",
      });
    }
  }, [initialPortadaData]);

  const validate = () => !portadaData.title || (!portadaData.image && !isEdit);

  const handleChange = (field) => (event) => {
    setPortadaData({ ...portadaData, [field]: event.target.value });
  };

  const handleImageChange = (event) => {
    setPortadaData({ ...portadaData, image: event.target.files[0] });
  };

  const handleSubmit = async () => {
    if (validate()) return;
    setLoading(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("title", portadaData.title);
      formDataToSend.append("seccion_id", portadaData.seccion_id);
      if (!isEdit) formDataToSend.append("documento_id", idDocument);
      
      if (portadaData.image && portadaData.image instanceof File) {
        formDataToSend.append("image", portadaData.image);
      }

      const url = isEdit
        ? getUpdatePortadaURL(initialPortadaData.id)
        : getAddPortadaURL();

      const method = isEdit ? "PUT" : "POST";

      const response = await fetch(url, {
        method,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formDataToSend,
      });

      const result = await response.json();

      if (response.ok) {
        toastAlert(
          isEdit ? "Portada actualizada correctamente" : "Portada agregada correctamente",
          "success",
          3000
        );
        setPortadaData({ title: "", image: null });
        close();
        refresh();
      } else {
        toastAlert(`Error: ${result.message || "No se pudo completar la acción"}`, "error");
      }
    } catch (error) {
      toastAlert(`Error al enviar la petición: ${error}`, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={close}>
      <Paper
        elevation={2}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          padding: "20px",
          width: "70%",
          outline: "none",
        }}
      >
        <Grid container spacing={2} justifyContent="space-between" alignItems="center">
          <Grid item xs={10}>
            <Typography variant="h6">
              {isEdit ? "Editar Portada" : "Agregar nueva portada"}
            </Typography>
          </Grid>
          <Grid item xs={2} style={{ textAlign: "right" }}>
            <IconButton
              onClick={() => {
                setPortadaData({ title: "", image: null });
                close();
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>

        <Grid container spacing={3} style={{ marginTop: "10px" }}>
          <Grid item xs={12} md={4}>
            <TextField
              label="Título"
              variant="outlined"
              value={portadaData.title}
              onChange={handleChange("title")}
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel id="select-autowidth-label">Sección</InputLabel>
              <Select
                labelId="select-autowidth-label"
                id="select-autowidth"
                value={portadaData.seccion_id}
                onChange={handleChange("seccion_id")}
                autoWidth
                label="Seccion"
              >
                {availableSections.length > 0 ? (
                  availableSections.map((item) => (
                    <MenuItem key={item.ID_SECCION} value={item.ID_SECCION}>
                      {item.NOMBRE_SECCION}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No hay secciones disponibles</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4} style={{ textAlign: "right" }}>
            <Input
              accept="image/*"
              type="file"
              id="upload-file"
              onChange={handleImageChange}
              style={{ display: "none" }}
            />
            <label htmlFor="upload-file">
              <Button
                variant="outlined"
                component="span"
                color="primary"
                sx={{
                  color: theme.palette.mode === "dark" ? "#fff" : "black",
                  width: "100%",
                  padding: "14px"
                }}
              >
                {portadaData.image
                  ? portadaData.image instanceof File
                    ? portadaData.image.name
                    : portadaData.imagen
                  : "Subir archivo PDF"}
              </Button>
            </label>
          </Grid>
        </Grid>

        <Grid container justifyContent="flex-end" style={{ marginTop: "20px" }}>
          <LoadingButton
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            loading={loading}
            disabled={validate()}
          >
            {isEdit ? "Guardar Cambios" : "Agregar Portada"}
          </LoadingButton>
        </Grid>
      </Paper>
    </Modal>
  );
};

export default AddPortadas;
